module["exports"] = [
  " s/n.",
  ", #",
  ", ##",
  " #",
  " ##"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/es/address/building_number.js
// module id = 1223
// module chunks = 1